module.exports = __webpack_public_path__ + "static/media/padang.fe724c71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/padang.jpg
// module id = 130
// module chunks = 0